const moment = require('moment-timezone');
const fees = require('./data/fees.js');

const updatedJan2025Fees = require('./data/feesJan2025.js');

const isFeesJanTestingEnabled = process.env.FEES_JAN_2025_TESTING_ENABLED;

const LONDON_TIMEZONE = 'Europe/London';

const currentLondonTime = () => moment().tz(LONDON_TIMEZONE);

/**
 * New fees have been loaded for 2025 January.
 * These are due to be released on 1st January 2025 after sale and before next sale 7PM.
 * After launch, isUpdatedEaster2024Fees check and related FTs can be removed.
 * Plus feesJan2025.js data file can be renamed back to fees.
 */

const isNewFeesLaunch = (date) => {
  /**
   * Convert date to London time zone.
   * Payments send us UTC time, so we need to convert it to London time zone.
   * This is because the fees are based on London time zone.
   * Jan is in GMT which is UTC+0. But as precaution, we are converting it to London time zone.
   */
  const targetTimeLondon = moment.tz(date, 'UTC').tz('Europe/London');

  const newFeesLaunchDate = moment.tz('2025-01-01T19:00:00', 'Europe/London');

  return targetTimeLondon.isSameOrAfter(newFeesLaunchDate);
};

const isUpdatedJan2025Fees = (date) =>
  isNewFeesLaunch(date) || isFeesJanTestingEnabled;

const getFees = (date) =>
  (isUpdatedJan2025Fees(date) ? updatedJan2025Fees : fees);

const calculateFee = (amount, date = currentLondonTime()) =>
  (amount
    ? getFees(date).find((fee) => amount <= fee.priceTo || !fee.priceTo)
      .brokerFee
    : null);

module.exports = {
  getFees,
  calculateFee,
};
